// import { FormControl, ValidationErrors } from '@angular/forms';

// export function urlValidator(control: FormControl): ValidationErrors | null {
//   const urlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/.test(control.value);
//   return urlRegex ? null : { 'invalidUrl': true };
// }

import { AbstractControl, ValidationErrors } from '@angular/forms';

export function urlValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null; // Don't validate if the field is empty (you might want to add Validators.required separately)
  }
  const urlRegex = /^https:\/\/([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/.test(control.value);
  return urlRegex ? null : { 'invalidUrl': true };
}